import { Facility } from '@reliance/types/models/Facility';
import { composeValidators } from '@reliance/forms-js/lib/validation';
import React from 'react';
import Form from 'react-bootstrap/Form';
import FormGroup from 'react-bootstrap/FormGroup';
import { Field } from 'react-final-form';
import { IFacility } from '../models/facility';
import { groupByState } from './StateGroupedCheckboxes';

type StateGroupedSelectProps = {
  name: string;
  label: string;
  facilities: IFacility[] | Facility[];
  emptyLabel?: string;
  validationRules?: any[];
  disabled?: boolean;
};

const StateGroupedSelect: React.FC<StateGroupedSelectProps> = (props) => {
  const facilitiesByState = groupByState(props.facilities);
  const sortedStates = Object.keys(facilitiesByState).sort();

  return (
    <Field
      name={props.name}
      validate={composeValidators(props.validationRules || [])}>
      {({ input, meta }) => {
        const selectValue =
          input.value != null && input.value !== ''
            ? String(input.value)
            : '';
        return (
          <FormGroup>
            <Form.Label>{props.label}</Form.Label>
            <select
              name={input.name}
              id={props.name}
              className={`form-control ${meta.touched && meta.error ? 'has-error' : ''}`}
              disabled={meta.submitting || props.disabled}
              value={selectValue}
              onChange={(e) => input.onChange(e.target.value)}
              onBlur={input.onBlur}
              onFocus={input.onFocus}>
              <option value="">{props.emptyLabel ?? 'None'}</option>
              {sortedStates.map((state) => {
                const facilitiesInState = [...facilitiesByState[state]].sort(
                  (a, b) => a.name.localeCompare(b.name)
                );
                return (
                  <optgroup key={state} label={state}>
                    {facilitiesInState.map((f) => (
                      <option key={f.id} value={String(f.id)}>
                        {f.name}
                      </option>
                    ))}
                  </optgroup>
                );
              })}
            </select>
            {(meta.error && meta.touched) && (
              <span className="help-block has-error">{meta.error}</span>
            )}
          </FormGroup>
        );
      }}
    </Field>
  );
};

export default StateGroupedSelect;
